import { useContext } from "react";
import { GroupContext } from "../provider";

export const useCurrentGroupId = (): [string | undefined, (groupId?: string | undefined) => void] => {
    const { currentGroupId, setCurrentGroupId } = useContext(GroupContext);

    return [currentGroupId, setCurrentGroupId];
};

export default useCurrentGroupId;
